/** @jsxImportSource @emotion/react */

import Image from 'next/image';

import Button from '@stories/atoms/Button';
import { media } from '@stories/theming/settings';
import imageLoader from '@utils/imageLoader';

import { headlines } from './VitafyAboutUsPage';

const exclusiveBrandsProps = {
  brandTeasers: [
    {
      href: '/bodylab-24.html',
      backgroundImagePath: '/vitafy/about-us/bl.png',
      logoSvgPath: 'https://cdn11.vitafy.de/vitafy/image/upload/Bodylab%20CH/logo-bodylab_ch.svg',
      description: 'Der Preis-Leistungs-Sieger - breite Auswahl an exzellenten Fitness Produkten.'
    },
    {
      href: '/gymqueen.html',
      backgroundImagePath: '/vitafy/about-us/gq.png',
      logoSvgPath: 'https://cdn11.vitafy.de/vitafy/image/upload/vitafy/about-us/gq-logo.svg',
      description: 'Gezielt Abnehmen und Gewicht halten – smart & tasty in shape.'
    },
    {
      href: '/lineavi.html',
      backgroundImagePath: '/vitafy/about-us/lineavi.png',
      logoSvgPath: 'https://cdn11.vitafy.de/vitafy/image/upload/vitafy/about-us/lineavi-logo.svg',
      description: 'Innovative Nahrungsergänzung für jeden Tag – everyday’s a feel good day.'
    },
    {
      href: '/vom-achterhof.html',
      backgroundImagePath: '/vitafy/about-us/va.png',
      logoSvgPath: 'https://cdn11.vitafy.de/vitafy/image/upload/vitafy/about-us/va-logo.svg',
      description: 'Der Experte für unverfälschte Natur- und Gesundheitsprodukte.'
    }
  ]
};

export type BrandTeaserProps = {
  href: string;
  backgroundImagePath: string;
  logoSvgPath: string;
  description: string;
};

export const BrandTeaser: React.FC<BrandTeaserProps> = ({
  href,
  backgroundImagePath,
  logoSvgPath,
  description
}) => {
  return (
    <a
      href={href}
      css={{
        [media('tablet')]: { flex: '0 0 calc(50% - 1rem)', margin: '.5rem' },
        [media('desktop')]: { flex: '0 0 calc(25% - 1rem)' }
      }}
    >
      <div
        css={{
          background: 'black',
          marginTop: '1rem',
          overflow: 'hidden',
          position: 'relative',
          aspectRatio: '.666',
          ':hover .brand-teaser-image': {
            transform: 'scale(1.1)'
          }
        }}
      >
        <Image
          className="brand-teaser-image"
          loader={imageLoader}
          src={backgroundImagePath}
          alt="Bodylab"
          fill
          // @ts-expect-error static important
          css={{
            transition: 'transform 200ms ease-in-out',
            height: 'auto !important',
            position: 'static !important'
          }}
        />
        <Image
          loader={imageLoader}
          src={logoSvgPath}
          alt="Bodylab"
          unoptimized
          fill
          css={{
            height: 'auto !important',
            maxWidth: '200px !important',
            top: '2rem !important',
            left: 'calc(50% - 100px) !important'
          }}
        />
        <div
          css={{
            backgroundColor: 'hsl(0 0% 0% / 8%)',
            backdropFilter: 'blur(30px)',
            color: 'white',
            padding: '1rem',
            position: 'absolute',
            bottom: 0,
            left: 0,
            fontSize: '14px',
            textAlign: 'center'
          }}
        >
          <p>{description}</p>
          <Button
            label={'Entdecken'}
            size="small"
            buttonStyle="secondary"
            cssProps={{ margin: 'auto', marginTop: '1rem', pointerEvents: 'none' }}
          />
        </div>
      </div>
    </a>
  );
};

export const ExclusiveBrands: React.FC = () => {
  return (
    <div>
      <header css={{ textAlign: 'center' }}>
        <h2 css={headlines.h3}>Exclusiv bei Vitafy</h2>
      </header>
      <div
        css={{
          marginTop: '2rem',
          [media('tablet')]: { display: 'flex', flexWrap: 'wrap', margin: '1rem .5rem' }
        }}
      >
        {exclusiveBrandsProps.brandTeasers.map((brandTeaser) => (
          <BrandTeaser key={brandTeaser.href} {...brandTeaser} />
        ))}
      </div>
      <div css={{ padding: '2rem 0 2rem' }}>
        <Button
          label={'Zu den Produkten'}
          href="/search?q="
          outline
          size="big"
          cssProps={{ maxWidth: '20rem', margin: 'auto' }}
        />
      </div>
    </div>
  );
};
